import { action, observable, reaction, runInAction } from "mobx";
import alertToast from "Util/ToastifyUtils";
import { CreditProviderEndpoints } from "../endpoints/CreditProviderEndpoints";
import { OrganisationProviderSummary } from "../types/CreditProviderItemStoreType";
import { IOrganisationProviderStore } from "../types/OrganisationProviderStoreType";

export class OrganisationProviderStore implements IOrganisationProviderStore {
	@observable isLoading: boolean = false;
	@observable hasError: boolean = false;
	@observable providerId: string;
	@observable pageNo: number = 1;
	@observable pageSize: number = 10;
	@observable totalCount: number = 0;
	@observable organisationProviders: OrganisationProviderSummary[] = [];
	@observable bulkActionLoading: boolean = false;

	constructor () {
		reaction(
			() => [this.pageNo, this.providerId],
			async () => {
				await this.getOrganisationProviders();
			}
		)
	}

	@action reset = () => {
		this.isLoading = false;
		this.hasError = false;
		this.pageNo = 1;
		this.pageSize = 10;
		this.totalCount = 0;
		this.organisationProviders = [];
		this.providerId = '';
	}

	@action setProviderId = (providerId: string) => {
		this.providerId = providerId;
	}

	@action setPageNo = (pageNo: number) => {
		this.pageNo = pageNo;
	}

	@action getOrganisationProviders = async () => {
		this.isLoading = true;
		this.hasError = false;

		if (!!!this.providerId) {
			this.isLoading = false;
			return;
		}

		const result = await CreditProviderEndpoints.getOrganisationProviders(this.pageNo, this.pageSize, this.providerId);
		runInAction(() => {
			this.organisationProviders = result.data;
			this.pageNo = result.pageNo;
			this.pageSize = result.pageSize;
			this.totalCount = result.totalCount;
			this.isLoading = false;
		});
	}

	@action toggleAll = async (isEnabled: boolean) => {
		this.hasError = false;
		this.bulkActionLoading = true;
		// force to enable the product for all organisations
		const result = await CreditProviderEndpoints.updateOrganisationProviderLink(this.providerId, isEnabled, undefined);

		runInAction(() => {
			if (!result) {
				console.error("Error updating provider link");
				alertToast("Failed to update the provider link", "error");
				this.hasError = true;
				this.bulkActionLoading = false;
				return;
			}
			this.organisationProviders = this.organisationProviders.map(x => {
				x.isLinked = isEnabled;
				return x;
			});
			this.bulkActionLoading = false;
			alertToast("Successfully enabled provider for all organisation", "success");
		})
	}

	@action updateOrganisationProviderLink = async (organisationId: string, enableProduct: boolean) => {
		this.hasError = false;

		const result = await CreditProviderEndpoints.updateOrganisationProviderLink(this.providerId, enableProduct, organisationId);
		runInAction(() => {
			if (!result) {
				console.error("Error linking organisation provider");
				alertToast("Failed to link the organisation", "error");
				this.hasError = true;
				return;
			}
			this.organisationProviders = this.organisationProviders.map(x => {
				if (x.organisationId === organisationId) {
					x.isLinked = !x.isLinked;
				}
				return x;
			});

			this.hasError = false;
			alertToast("Successfully linked organisation provider", "success");
		})
	}
}